<script setup>
defineProps({
  itemParaEditar: { type: Object, default: null }
})
defineEmits(['itemAtualizado', 'cancelar', 'show-notification'])
</script>
<template>
  <div class="p-5 text-center">
    <i class="bi bi-box-seam fs-1 text-success mb-3 d-block"></i>
    <h4 class="text-body-emphasis">Estocagem</h4>
    <p class="text-body-secondary">Módulo em desenvolvimento.</p>
  </div>
</template>
